import { render } from "./Spacer.vue?vue&type=template&id=7f65d135"
import script from "./Spacer.vue?vue&type=script&lang=js"
export * from "./Spacer.vue?vue&type=script&lang=js"

import "@/assets/css/tailwind.css?vue&type=style&index=0&lang=css&external"
import "@/assets/css/_fontface.css?vue&type=style&index=1&lang=css&external"
import "@/assets/css/_variables.css?vue&type=style&index=2&lang=css&external"
import "@/assets/css/_global.css?vue&type=style&index=3&lang=css&external"
import "@/assets/css/_animations.css?vue&type=style&index=4&lang=css&external"
import "@/assets/css/main.css?vue&type=style&index=5&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__